'use strict';

import NS from 'src/ns';
import $ from 'jquery';
import smoothScroll from 'src/utility/smoothScroll';
import forEach from 'lodash/each';
import assign from 'lodash/assign';
import defer from 'lodash/defer';

class Drawer {
  constructor($target) {
    this.$block = $target;
    this.opened = false;
    this.ns = '.' + Drawer.BEM.block;
  }

  init() {
    this.addEvent();
  }

  addEvent() {
    const ns = this.ns;

    $(document)
      .on('click' + ns, 'button[aria-controls=' + Drawer.BEM.block + ']', this.onClickTrigger.bind(this));

    this.$block
      .on('click' + ns, 'a[href^="#"]', this.onClickHash.bind(this));
  }

  onClickTrigger(e) {
    this.changeDrawerState($(e.currentTarget));
  }

  onClickHash(e) {
    e.preventDefault();

    let position = smoothScroll.getPosition($(e.target));

    smoothScroll.forceScroll(0, position);

    defer(this.changeDrawerState.bind(this));
  }

  changeDrawerState($drawerButton) {
    let M = Drawer.BEM.modifier;

    this.opened = !this.opened;

    this.transitionendEventListener(this.opened);
    $('html').toggleClass(M.opened, this.opened);
    this.$block.attr('aria-hidden', !this.opened);

    if ($drawerButton) {
      $drawerButton.attr('aria-selected', this.opened);
    } else {
      $('button[aria-controls=' + Drawer.BEM.block + ']').attr('aria-selected', false);
    }
  }

  transitionendEventListener(drawerOpened) {
    const ns = this.ns;

    if (drawerOpened) {
      this.$block.off('transitionend' + ns);
    } else {
      this.$block.on('transitionend' + ns, this.overflowPositionReset.bind(this));
    }
  }

  overflowPositionReset(e) {
    if (e.originalEvent.propertyName === 'opacity') {
      this.$block[0].scrollTop = 0;
      this.transitionendEventListener(this.opened);
    }
  }
}

assign(Drawer, {
  BEM: {
    block: 'stl-Drawer',
    element: {},
    modifier: {
      opened: '-drawerOpened'
    }
  },
  create: function(element) {
    const $target = element ? $(element): $('.' + Drawer.BEM.block).first();

    if (!$target.length) return;

    new Drawer($target).init();
  },
  createAll() {
    let $target = $('.' + Drawer.BEM.block);

    if (!$target.length) return;

    forEach($target, (target) => {
      Drawer.create(target);
    });
  }
});


export default NS.Drawer = Drawer;


// WEBPACK FOOTER //
// ./htdocs/assets/src/javascripts/block/drawer.js